import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { useState } from 'react'
import { AuthProvider } from './contexts/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'
import Sidebar from './components/Sidebar'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Customers from './pages/Customers'
import ExpenseManager from './pages/ExpenseManager'
import ExpenseHistory from './pages/ExpenseHistory'
import Settings from './pages/Settings'
import OAuthCallback from './pages/OAuthCallback'
import ReportAnalysis from './pages/ReportAnalysis'
import BudgetTransactions from './pages/BudgetTransactions'
import AuditLog from './pages/AuditLog'

// 禁用 React Router 未來版本警告
if (typeof window !== 'undefined') {
  const originalWarn = console.warn;
  console.warn = (...args) => {
    if (
      typeof args[0] === 'string' && 
      (args[0].includes('React Router Future Flag Warning') ||
       args[0].includes('v7_startTransition') ||
       args[0].includes('v7_relativeSplatPath'))
    ) {
      return;
    }
    originalWarn(...args);
  };
}

function App() {
  const [sidebarOpen, setSidebarOpen] = useState(true)

  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* 公開路由 - 登入頁面 */}
          <Route path="/login" element={<Login />} />
          <Route path="/oauth-callback" element={<OAuthCallback />} />
          
          {/* 受保護的路由 - 需要登入 */}
          <Route path="/*" element={
            <ProtectedRoute>
              <div className="flex h-screen bg-gray-50">
                <Sidebar open={sidebarOpen} setOpen={setSidebarOpen} />
                
                <main className={`flex-1 overflow-y-auto transition-all duration-300 ${sidebarOpen ? 'ml-64' : 'ml-20'}`}>
                  <Routes>
                    <Route path="/" element={<Navigate to="/dashboard" replace />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/customers" element={<Customers />} />
                    <Route path="/expense-manager" element={<ExpenseManager />} />
                    <Route path="/expense-history" element={<ExpenseHistory />} />
                    <Route path="/budget-transactions" element={<BudgetTransactions />} />
                    <Route path="/report-analysis" element={<ReportAnalysis />} />
                    <Route path="/audit-logs" element={<AuditLog />} /> {/* admin only - sidebar 已過濾 */}
                    <Route path="/settings" element={<Settings />} />
                  </Routes>
                </main>
              </div>
            </ProtectedRoute>
          } />
        </Routes>
      </AuthProvider>
    </Router>
  )
}

export default App
